import TinCan from "tincanjs";
import TinCanConstants from "../../constants/tincan";
import _ from "lodash";

export default class StatementGenerator {

	static generateHistoryStatement(historyItem, srcObj, activity, rootActivity, agent, lang) {

		let type = historyItem.type;
		let statement;

		switch (type) {
			case "activity":
				statement = this.generateActivityStatement(historyItem, srcObj, activity, rootActivity, agent, lang);
				break;
			case "list":
				statement = this.generateListStatement(historyItem, srcObj, activity, rootActivity, agent, lang);
				break;
			case "section":
				statement = this.generateSectionStatement(historyItem, srcObj, activity, rootActivity, agent, lang);
				break;
			case "item":
				statement = this.generateItemStatement(historyItem, srcObj, activity, rootActivity, agent, lang);
				break;
			default:
				break;
		}

		return statement;
	}

	static generateActivityStatement(historyItem, ambifiActivity, activity, rootActivity, agent, lang) {

		let verb = new TinCan.Verb({
			id: TinCanConstants.AMBIFI_VERBS_BASE_URI + "/" + historyItem.action
		});

		let statementCfg = {
			verb: verb,
			context: this.buildContext(activity, rootActivity),
			object: activity,
			timestamp: TinCan.Utils.getISODateString(new Date())
		}

		if (!_.isUndefined(agent)) statementCfg.actor = agent;

		let statement = new TinCan.Statement(statementCfg);
		return statement;
	}

	static generateListStatement(historyItem, list, activity, rootActivity, agent, lang) {

		let verb = new TinCan.Verb({
			id: TinCanConstants.AMBIFI_VERBS_BASE_URI + "/" + historyItem.action
		});

		let statementCfg = {
			verb: verb,
			context: this.buildContext(activity, rootActivity),
			object: {
				id: activity.id + "/lists/" + list.guid,
				type: TinCanConstants.AMBIFI_ACTIVITY_TYPES.LIST,
				name: {
					[lang]: list.name
				}
			},
			timestamp: TinCan.Utils.getISODateString(new Date())
		}

		if (!_.isUndefined(agent)) statementCfg.actor = agent;

		let statement = new TinCan.Statement(statementCfg);
		return statement;
	}

	static generateSectionStatement(historyItem, section, activity, rootActivity, agent, lang) {

		let verb = new TinCan.Verb({
			id: TinCanConstants.AMBIFI_VERBS_BASE_URI + "/" + historyItem.action
		});

		let statementCfg = {
			verb: verb,
			context: this.buildContext(activity, rootActivity),
			object: {
				id: activity.id + "/sections/" + section.guid,
				type: TinCanConstants.AMBIFI_ACTIVITY_TYPES.SECTION,
				name: {
					[lang]: section.name
				}
			},
			timestamp: TinCan.Utils.getISODateString(new Date())
		};

		if (!_.isUndefined(agent)) statementCfg.actor = agent;

		let statement = new TinCan.Statement(statementCfg);
		return statement;
	}

	static generateItemStatement(historyItem, item, activity, rootActivity, agent, lang) {

		let verb = new TinCan.Verb({
			id: TinCanConstants.AMBIFI_VERBS_BASE_URI + "/" + historyItem.action
		});

		let object = {
			id: activity.id + "/items/" + item.guid,
			definition: {
				type: TinCanConstants.AMBIFI_ACTIVITY_TYPES.ITEM,
				name: {
					[lang]: item.label1
				},
				description: {
					[lang]: item.label2
				}
			}
		};

		let result;
		if (historyItem.value) {
			let response;

			if (_.isObject(historyItem.value)) {
				response = JSON.stringify(historyItem.value);
			} else {
				response = historyItem.value + "";
			}

			result = new TinCan.Result({
				response: response
			});
		}

		let statementCfg = {
			verb: verb,
			context: this.buildContext(activity, rootActivity),
			object,
			result,
			timestamp: TinCan.Utils.getISODateString(new Date())
		};

		if (!_.isUndefined(agent)) statementCfg.actor = agent;

		let statement = new TinCan.Statement(statementCfg);
		return statement;
	}

	static generateExitStatements(rootActivity, agent) {

		let suspendStatementCfg = {
			verb: new TinCan.Verb({ id: TinCanConstants.ADL_VERBS.SUSPENDED }),
			object: rootActivity,
			timestamp: TinCan.Utils.getISODateString(new Date())
		};

		if (!_.isUndefined(agent)) suspendStatementCfg.actor = agent;

		let suspendStatement = new TinCan.Statement(suspendStatementCfg);

		let terminatedStatementCfg = {
			verb: new TinCan.Verb({ id: TinCanConstants.ADL_VERBS.TERMINATED }),
			object: rootActivity,
			timestamp: TinCan.Utils.getISODateString(new Date())
		};

		if (!_.isUndefined(agent)) terminatedStatementCfg.actor = agent;

		let terminatedStatement = new TinCan.Statement(terminatedStatementCfg);

		return [suspendStatement, terminatedStatement];
	}

	static generateInitializeStatement(rootActivity, agent) {

		let initializeStatementCfg = {
			verb: new TinCan.Verb({ id: TinCanConstants.ADL_VERBS.INITIALIZED }),
			object: rootActivity,
			timestamp: TinCan.Utils.getISODateString(new Date())
		};

		if (!_.isUndefined(agent)) initializeStatementCfg.actor = agent;

		let initializeStatement = new TinCan.Statement(initializeStatementCfg);

		return initializeStatement;
	}

	static buildContext(activity, rootActivity) {

		let context = new TinCan.Context({
			contextActivities: new TinCan.ContextActivities({
				parent: [
					{
						id: activity.id,
						objectType: "Activity"
					}
				],
				grouping: [
					{
						id: rootActivity.id,
						objectType: "Activity"
					}
				]
			})
		});

		return context;
	}
}